import { OVER_ALL_STATUS } from '../../constants';
import { statusBarColors } from './CoolingAnomalyChart/constants';

const CONDITION_BY_NORMALIZED_KEY = {
    good: 'Good',
    tolerable: 'Tolerable',
    poor: 'Poor',
    unknown: 'Unknown'
};

export const getKpiConditionLabel = (kpi) => {
    const rawCondition = kpi?.currentCondition ?? kpi?.condition;
    const normalizedCondition = typeof rawCondition === 'string'
        ? rawCondition.trim().toLowerCase()
        : '';

    return CONDITION_BY_NORMALIZED_KEY[normalizedCondition] || 'Unknown';
};

export const getKpiConditionStatus = (kpi) => OVER_ALL_STATUS[getKpiConditionLabel(kpi)] ?? OVER_ALL_STATUS.Unknown;

export const getKpiStatusColor = (kpi) => statusBarColors[getKpiConditionLabel(kpi)] || statusBarColors.Unknown;
